var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('c-header'),_c('div',{staticClass:"wrap"},[_c('c-menu'),_c('div',{staticClass:"content wrap-content"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }